"use strict";

import $ from "jquery";
import numeral from "numeral";

module.exports = function(chart) {
  if (chart.customPieTitle) {
    chart.customPieTitle.destroy();
  }

  const r = chart.renderer;
  const x = chart.series[0].center[0] + chart.plotLeft;
  let y = chart.series[0].center[1] + chart.plotTop;

  let div = "<div style='text-align:center; color: black;'>";

  let totalHeading = chart.options.pie_chart_title;

  if (chart.options.template === "ItalyIndustrialProductionByIndustrialSector") {
    totalHeading = "Industrial production<br>(2016)";
  } else if (chart.options.template === "FinanceReportInvestment") {
    totalHeading = "Average annual<br> investment needs<br>(2018-30)";
    y -= y / 10;
  } else if (chart.options.template === "FinanceReportCapexByFunding") {
    totalHeading = "Average annual CAPEX<br> (2013-17)";
    y -= y / 15;
  } else if (chart.options.template.match("DonutFanChart")) {
    y -= y / 45;
  }

  // HC7's buildText dropped the inline style + <b> when converting div->tspan in SVG mode.
  // HC13's AST TextBuilder now honors both — matches production, which renders this bold.
  div += "<div style='font-size: " + 13 + "px; font-weight: bold'>" + totalHeading + "</div><br>";

  let total = chart.series[0].total;
  if (chart.options.template.match("DonutFanChart")) {
    total = total / 6;
  }

  let tooltip = chart.tooltip.options.formatter && chart.tooltip.options.formatter.apply({ y: total });
  if (!tooltip) {
    return;
  }
  let number = $(tooltip).find("div").last().text();

  if (number.slice(-1) === "%" && total > 100) {
    tooltip = chart.tooltip.options.formatter.apply({ y: 100 });
    number = $(tooltip).find("div").last().text();
  }

  if (total > 100) {
    total = 100;
  }

  if (chart.options.template === "ChinaPppFundExample") {
    const usd = Math.round(total * 160) / 100;
    const cny = Math.round(total * 1) / 100;
    number  = "CNY " + cny + " billion<br>($" + usd + " million)";
  } else if (chart.options.template === "ItalyIndustrialProductionByIndustrialSector") {
    const euro = Math.round(total * 894.403) / 100;
    const usd = Math.round(total * 1252.1) / 100;

    number = "€" + euro + " billion<br>" + "($" + usd + " bn)";
  }

  if (chart.options.customTotal) {
    const raw_population = (chart.options.customTotal.raw_value * total) / 100;
    const formated_total = numeral(raw_population).format("0a").toUpperCase();
    number = formated_total + chart.options.customTotal.prefix;
  }

  if (chart.options.template === "CompanyBusinessSegment") {
    var total_attrs = number.replace(/\d+/g, "").replace(/\d+/g, "").split(".").join("").split(",").join("").split(" ");

    var total_unit = total_attrs[0];
    var total_prefix = total_attrs[1];
    number = total_unit + chart.options.totalWithNegatives + " " + total_prefix;
  }

  const valueAndUnits = number.split(" ");
  let value = "", units = "";

  if (number.length >= 22 && chart.options.template !== "ItalyIndustrialProductionByIndustrialSector" && chart.options.template !== "ChinaPppFundExample") {
    value = valueAndUnits[0];
    units = valueAndUnits.slice(1).join(" ");
  } else {
    value = valueAndUnits.join(" ");
  }

  if (!chart.options.hideValues) {
    div += "<div style='font-size: " + 15 + "px'>" + value + "<br>" + units + "</div>";
  }
  div += "</div>";

  chart.customPieTitle = r.text(div).hide().add();

  chart.customPieTitle.attr({
    x: x,
    y: y,
    "text-anchor": "middle"
  }).show();
};
